import type {MatchMode} from '@wandb/weave/common/util/columnMatching';
import {TailwindContents} from '@wandb/weave/components/Tailwind';
import React from 'react';

import type {Config} from '../../../util/runfeed';
import {TableEditorColumns} from './TableEditorColumns';
import {TableEditorSearch} from './TableEditorSearch';
import {useTableEditorSearchMatches} from './useTableEditorSearchMatches';

interface TableEditorProps {
  config: Config;
  allColumns: string[];
  fixedColumns: string[];
  searchQuery: string;
  searchMode: MatchMode;
  setMatchMode: (mode: MatchMode) => void;
  setSearch(search: string): void;
  update(config: Config): void;
}

export function TableEditor({
  config,
  allColumns,
  fixedColumns: fixedColumnsProp,
  searchQuery,
  searchMode,
  setMatchMode,
  setSearch,
  update,
}: TableEditorProps) {
  const {
    fixedColumns,
    hiddenColumns,
    highlightColumn,
    pinnedColumns,
    visibleColumns,
  } = useTableEditorSearchMatches({
    allColumns,
    config,
    fixedColumns: fixedColumnsProp,
    searchMode,
    searchQuery,
  });

  return (
    <TailwindContents>
      <div className="flex flex-col gap-16">
        <TableEditorSearch
          onSetMatchMode={setMatchMode}
          onSetSearch={setSearch}
          search={searchQuery}
          matchMode={searchMode}
        />
        <TableEditorColumns
          config={config}
          fixedColumns={fixedColumns}
          hiddenColumns={hiddenColumns}
          highlightColumn={highlightColumn}
          pinnedColumns={pinnedColumns}
          update={update}
          visibleColumns={visibleColumns}
        />
      </div>
    </TailwindContents>
  );
}
